import statesArray from '../../utils/statesArray';

const formData = {
    questionSetId: 'Clearance',
    name: 'Clearance',

    questions: [
        {
            questionId: '0',
            text: 'Named Insured',
            name: 'primaryInsuredNameLabel',
            inputType: 'label'
        },
        {
            questionId: '1',
            text: 'Who is the Named Insured?',
            name: 'primaryInsuredName',
            inputType: 'text',
            inputFormat: 'text',
            placeholder:
                'This entity must be named as the Owner in the contract receiving hold harmless, indemnification and additional insured status from the hired General Contractor',
            placeholderHidden: true,
            required: true
        },
        {
            questionId: '2',
            name: 'primaryAddressLabel',
            text: `What is the Named Insured's address?`,
            inputFormat: 'label',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2a',
            name: 'primaryInsuredAddress',
            inputFormat: 'text',
            inputType: 'googleSearch',
            required: true,
            placeholder: 'Address',
            autofillFields: {
                'address': 'primaryInsuredAddress',
                'city': 'primaryInsuredCity',
                'state': 'primaryInsuredState',
                'zipcode': 'primaryInsuredZipcode'
            },
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2b',
            name: 'primaryInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2c',
            name: 'primaryInsuredState',
            inputType: 'dropdown-single',
            required: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2d',
            name: 'primaryInsuredZipcode',
            inputType: 'text',
            inputFormat: 'text',
            required: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '3',
            name: 'primaryAddressLabel',
            text: 'What is the address of the project?',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'projectAddress'
            },
            placeholder: `This must be a single location, the policy is project specific. If Project Address is not available in the Google drop down, enter the Mailing Address for initial clearance and enter the location address/Parcel ID under project address on the next page.`,
            helperLabel: `Please Note: `,
            helper: 'Underwriter will confirm clearance shortly.',
            placeholderExposed: true
        },

        {
            questionId: '3e',
            name: 'Address',
            text: 'Same as above',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '3a',
            name: 'projectAddress',
            inputFormat: 'text',
            inputType: 'googleSearch',
            required: true,
            placeholder: 'Address',
            autofillFields: {
                'address': 'projectAddress',
                'city': 'projectCity',
                'state': 'projectState',
                'zipcode': 'projectZipcode'
            },
            stateRestriction: true,
            attributes: {
                controlGroup: 'projectAddress'
            }
        },

        {
            questionId: '3b',
            name: 'projectCity',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },

        {
            questionId: '3c',
            name: 'projectState',
            inputType: 'dropdown-single',
            required: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'projectAddress'
            }
        },

        {
            questionId: '3d',
            name: 'projectZipcode',
            inputType: 'text',
            inputFormat: 'text',
            required: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'projectAddress'
            }
        }
    ],

    supplementalQuestions: []
};

export default formData;
